"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Filters_1 = require("../../components/Filters/Filters");
var Pagination_1 = require("../../components/Pagination/Pagination");
require("./combined-press-release-page.scss");
(function () {
    if (document.querySelectorAll(".js-combined-press-release-page").length > 0) {
        var combinedPressReleasePage_1 = {
            init: function () {
                var urlParams = window.location.search;
                Filters_1.filters.init();
                Filters_1.filters.get(urlParams);
                Pagination_1.pagination.init();
                combinedPressReleasePage_1.addEventListeners();
            },
            addEventListeners: function () {
                var filterSubmit = document.getElementById("filter-submit");
                if (filterSubmit) {
                    filterSubmit.addEventListener("click", function (e) {
                        e.preventDefault();
                        var urlParams = Filters_1.filters.set().toString();
                        window.location.search = urlParams;
                    });
                }
            },
        };
        combinedPressReleasePage_1.init();
    }
})();
